/// <amd-module name="Build/Admin/Common/Components/ConfirmationDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";

import { ConfirmButtonType } from "Build/Admin/Common/Actions/ConfirmationDialogActions";
import { ConfirmationDialogStore } from "Build/Admin/Common/Stores/ConfirmationDialogStore";

import * as Resources from "Build/Admin/Common/Resources";

export interface IConfirmationDialogProps<T> {
    confirmationDialogStore: ConfirmationDialogStore<T>;
}

interface IConfirmationDialogState {
    isOpen: boolean;
    title: string;
    content: string | JSX.Element;
    confirmButtonType: ConfirmButtonType;
}

export class ConfirmationDialog<T> extends React.PureComponent<IConfirmationDialogProps<T>, IConfirmationDialogState> {
    constructor(props: IConfirmationDialogProps<T>) {
        super(props);
        this.state = this._getStateFromStores();
    }

    public componentDidMount(): void {
        this.props.confirmationDialogStore.addChangedListener(this._onStoreChanged);
    }

    public componentWillUnmount(): void {
        this.props.confirmationDialogStore.removeChangedListener(this._onStoreChanged);
    }

    public render(): JSX.Element | null {
        let confirmButtonText: string;
        let confirmButtonClass: string | undefined;
        let confirmButtonDanger = false;
        let confirmButtonPrimary = false;

        switch (this.state.confirmButtonType) {
            case ConfirmButtonType.Delete:
                confirmButtonText = Resources.Delete;
                confirmButtonClass = "confirm-delete-button";
                confirmButtonDanger = true;
                break;

            case ConfirmButtonType.Update:
                confirmButtonText = Resources.Update;
                confirmButtonPrimary = true;
                break;

            case ConfirmButtonType.ConfirmDanger:
                confirmButtonDanger = true;
            case ConfirmButtonType.Confirm:
            default:
                confirmButtonText = Resources.Confirm;
                confirmButtonPrimary = this.state.confirmButtonType != ConfirmButtonType.ConfirmDanger
        }

        if (this.state.isOpen) {
            return (
                <Dialog
                    className="pipelines-confirm-action-container"
                    titleProps={{
                        text: this.state.title
                    }}
                    footerButtonProps={[
                        {
                            onClick: this._onDismiss,
                            text: Resources.Cancel
                        },
                        {
                            className: confirmButtonClass,
                            danger: confirmButtonDanger,
                            onClick: this._onOkClick,
                            primary: confirmButtonPrimary,
                            text: confirmButtonText
                        }
                    ]}
                    onDismiss={this._onDismiss}
                >
                    {this.state.content}
                </Dialog>
            );
        }

        return null;
    }

    private _onOkClick = (ev: React.MouseEvent<HTMLButtonElement>): void => {
        if (this.props.confirmationDialogStore.state.onConfirm &&
            this.props.confirmationDialogStore.state.selectedItem) {
            this.props.confirmationDialogStore.state.onConfirm(this.props.confirmationDialogStore.state.selectedItem);
        }
    }

    private _onDismiss = (): void => {
        if (this.props.confirmationDialogStore.state.onCancel) {
            this.props.confirmationDialogStore.state.onCancel();
        }
    }

    private _onStoreChanged = (): void => {
        this.setState(this._getStateFromStores());
    }

    private _getStateFromStores = (): IConfirmationDialogState => {
        return {
            isOpen: this.props.confirmationDialogStore.state.isOpen,
            title: this.props.confirmationDialogStore.state.title,
            content: this.props.confirmationDialogStore.state.content,
            confirmButtonType: this.props.confirmationDialogStore.state.confirmButtonType
        };
    }
}
